'use client';

import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useRouter } from 'next/navigation';
import React from 'react';

function HeaderBack() {
  const router = useRouter();

  const handleBack = () => {
    try {
      window.flutter_inappwebview.callHandler('headerBackButtonClick');
    } catch (e) {
      router.back();
    }
  };

  return (
    <Button variant="ghost" className="pl-0" onClick={handleBack}>
      <ArrowLeft size={15} />
    </Button>
  );
}

export default HeaderBack;
